/**
 * map cent integers into db floats, i.e. 1215c = 12.15€
 * after we change all monetary values to cents, these conversions will be redundant
 */
export function centsToEur(cents: number): number {
  return parseFloat((cents / 100).toFixed(2))
}

/**
 * map eur values from db (floats) into cents as integer, i.e. 12.15€ = 1215c
 * after we change all monetary values to cents, these conversions will be redundant
 */
export function eurToCents(float: number) {
  if (!float) {
    return 0
  }

  return Math.round(float * 100)
}
